import { message, Modal, Spin, Button, Radio, Flex } from "antd";
import React, { useEffect, useRef, useState } from "react";
import InputFields from "../../utils/UserInput";
import { Formik, Form, useFormikContext } from "formik";
import { postRequest } from "../../utils/APICall";
import moment from "moment/moment";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { fetchingEmployeeErorr } from "../../redux/attendanceSlice";
import { SelectEmployee } from "../SelectInput";
import { XMarkIcon } from "@heroicons/react/16/solid";

const MarkAttModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [createdBy, setCreatedBy] = useState(null);
  const [EditBy, setEditBy] = useState(null);
  const [remarks, setRemarks] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const { users } = useSelector((state) => state.user || {});
  const { allEmployee } = useSelector((state) => state.employees);
  const formikRef = useRef();

  function removeDuplicatesByID(array) {
    const seen = new Set();
    return array.filter((item) => {
      if (seen.has(item.ID)) return false;
      seen.add(item.ID);
      return true;
    });
  }



  const filterData = removeDuplicatesByID(allEmployee);

  const initialValues = {
    empName: "",
    attDate: "",
    entryTime: "",
    leavingTime: "",
    description: "",
    workType: "Onsite",
    remoteReason: "",
  };

  const validationSchema = Yup.object().shape({
    empName: Yup.string().required("Employee Name is required"),
    attDate: Yup.string().required("Date is required"),
    leavingTime: Yup.string(),
    description: Yup.string(),
    workType: Yup.string(),
  });

  useEffect(() => {
    if (!open && formikRef.current) {
      formikRef.current.resetForm();
      setRemarks(null);
      setEditBy(null);
      setCreatedBy(null);
      setEmployeeId(null);
    }
  }, [open]);

  const searchAttendence = async (values, setFieldValue) => {
    const formatDate = moment(values?.attDate, "DD-MM-YYYY").format(
      "DD-MMMM-YYYY"
    );
    if (!values.empName || !values.attDate) {
      message.warning("Select Employee Or Date ");
      return;
    }

    const obj = {
      empid: values?.empName,
      todate: formatDate,
      fromdate: formatDate,
    };

    try {
      const response = await postRequest("getByEmpId", obj);
      console.log(response)
      if (response.error) {
        message.warning("Employee not found", 3);
        return;
      }

      let matchedData = null;
      for (const dept in response) {
        const employees = response[dept];
        matchedData = employees?.find(
          (item) => item?.id === parseInt(values?.empName)
        );
        if (matchedData) break;
      }

      if (matchedData) {
        const attendance = matchedData?.attendanceData[0];
        // console.log("attendance", attendance)
        setRemarks(attendance?.remark);

        const entryTime24hr = attendance?.entryTime
          ? moment(attendance?.entryTime, ["hh:mm A"]).format("HH:mm")
          : "";
        const leavingTime24hr = attendance?.leavingTime
          ? moment(attendance?.leavingTime, ["hh:mm A"]).format("HH:mm")
          : "";

        setFieldValue(
          "entryTime",
          moment(entryTime24hr, "HH:mm").isValid() ? entryTime24hr : ""
        );
        setFieldValue(
          "leavingTime",
          moment(leavingTime24hr, "HH:mm").isValid() ? leavingTime24hr : ""
        );
        setFieldValue("description", matchedData?.worksheet || "");
        setFieldValue("workType", attendance?.workType || "Onsite");
        setFieldValue("remoteReason", attendance?.reomoteReason || "");
        setFieldValue("description", attendance?.workDetail || "");
        setFieldValue("lateRemarks", attendance?.lateRemarks || "");
        setCreatedBy(attendance?.createdBy);
        setEditBy(attendance?.EditBy);
      } else {
        setFieldValue("entryTime", "");
        setFieldValue("leavingTime", "");
        setFieldValue("description", "");
      }
    } catch (error) {
      dispatch(fetchingEmployeeErorr());
      console.error(" Error in API request:", error);
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    const formatDateTime = (date, time, entryTime = null) => {
      if (!date || !time) return null;
      let dateTime = moment(`${date} ${time}`, "DD-MM-YYYY HH:mm");
      if (entryTime) {
        const entryDateTime = moment(
          `${date} ${entryTime}`,
          "DD-MM-YYYY HH:mm"
        );
        if (dateTime.isBefore(entryDateTime)) dateTime.add(1, "days");
      }
      return dateTime.format("YYYY-MM-DD HH:mm:ss");
    };

    const adjustLeavingTime = (entryDateTimeStr, leavingDateTimeStr) => {
      let entry = moment(entryDateTimeStr, "YYYY-MM-DD HH:mm:ss");
      let leaving = moment(leavingDateTimeStr, "YYYY-MM-DD HH:mm:ss");
      if (leaving.isBefore(entry)) leaving.add(1, "days");
      return leaving.format("YYYY-MM-DD HH:mm:ss");
    };

    const obj = {
      vempid: values.empName,
      ventrytime: formatDateTime(values.attDate, values.entryTime),
      vleaveingtime: values.leavingTime
        ? adjustLeavingTime(
          formatDateTime(values.attDate, values.entryTime),
          formatDateTime(values.attDate, values.leavingTime)
        )
        : null,
      vattendencedate: values.attDate
        ? moment(values.attDate, "DD-MM-YYYY").format("DD MMM YYYY")
        : null,
      vcreatedby: `${users?.FIRSTNAME} ${users?.LASTNAME} | ${moment(Date.now()).format(
        "DD-MM-YYYY HH:mm"
      )}`,
      vworksheet: values.description || null,
      vworkType: values.workType || null,
      vremoteReason: values.workType === "Onsite" ? null : values.remoteReason || null,
      lateRemarks : values.lateRemarks
    };
    // console.log(obj)
    try {
      const response = await postRequest("manualatt", obj);
      if (response.status) {
        message.success("Attendance Marked!");
        onClose();
        resetForm();
        setRemarks(null);
        setEditBy(null);
        setCreatedBy(null);
        window.location.reload();
      } else {
        resetForm();
        message.error("Error submitting attendance. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("Error submitting attendance. Please try again.");
    }
  };

  function AttendanceWatcher({ searchAttendence, setFieldValue }) {
    const { values } = useFormikContext();
    useEffect(() => {
      if (values.empName && values.attDate) {
        searchAttendence(values, setFieldValue);
      }
    }, [values.empName, values.attDate]);
    return null;
  }
  const options = [
    { label: 'Onsite', value: 'Onsite' },
    { label: 'Remote', value: 'Remote' },
  ];

  return (
    <div>
      <Modal
        title={
          <div className="text-xl font-bold text-center pb-3 dark:bg-gray-900 dark:text-white">
            Mark Attendance
          </div>
        }
        open={open}
        onCancel={onClose}
        footer={null}
        destroyOnClose
        className="dark:[&_.ant-modal-content]:bg-gray-900
               dark:[&_.ant-modal-content]:text-gray-100"
        closeIcon={
          <XMarkIcon
            className={"h-5 w-5  dark:text-white text-black"}
          />
        }
      >
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ setFieldValue, values, isSubmitting, submitForm }) => (
            <Form>
              <AttendanceWatcher
                searchAttendence={searchAttendence}
                setFieldValue={setFieldValue}
              />
              <div className="grid grid-cols-1 gap-2 md:grid-cols-2 ">
                <div className="col-span-2 ">
                  <label className="block font-semibold mb-1">
                    Employee Name <span className="text-red-500">*</span>
                  </label>
                  <SelectEmployee
                    employeeList={filterData}
                    onChange={(value) => {
                      setEmployeeId(value);
                      setFieldValue("empName", value);
                    }}
                    selectedEmployee={employeeId}
                    customStyle="w-full "
                    allLabel={{}}
                  />
                </div>

                <div className="col-span-2">
                  <InputFields
                    label="Date"
                    type="date"
                    placeholder="Select Date"
                    name="attDate"
                  />
                </div>
                <InputFields label="Entry Time" type="time" name="entryTime" />
                <InputFields
                  label="Leaving Time"
                  type="time"
                  name="leavingTime"
                />
                <div className="col-span-2">
                  <InputFields
                    label="Worksheet"
                    type="textarea"
                    placeholder="Enter Description"
                    name="description"
                  />
                </div>
                <div className="col-span-2">
                  <InputFields
                    label="Late Remarks"
                    type="textarea"
                    placeholder="Enter Late Remarks"
                    name="lateRemarks"
                  />
                </div>
              </div>
              <span className="">
                <Flex vertical gap="middle" className="mt-6">
                  <Radio.Group
                    block
                    size="large"
                    options={options}
                    defaultValue="Onsite"
                    value={values.workType}
                    className="dark:[&_.ant-radio-wrapper]:text-gray-200"
                    onChange={(e) => setFieldValue("workType", e.target.value)}
                  />
                </Flex>
              </span>
              <div className={`col-span-2 ${values.workType == "Remote" ? "block" : "hidden"}`}>
                <InputFields
                  label="Remote Reason"
                  type="textarea"
                  placeholder="Enter Remote Reason "
                  name="remoteReason"
                />
              </div>
              <span className="block font-bold pt-2 dark-text-white">
                Created By: <span>{createdBy}</span>
              </span>
              <span className="block font-bold pt-2 dark-text-white">
                Edit By: <span>{EditBy}</span>
              </span>
              <span className="block font-bold pt-2 dark-text-white">
                Remarks: <span>{remarks}</span>
              </span>

              <div className="flex justify-evenly gap-2">
                <Button
                  type="primary"
                  loading={isSubmitting}
                  className="mt-6 w-40 max-h-10 disabled:dark:text-white disabled:dark:bg-gray-500"
                  disabled={
                    !values.empName ||
                    !values.attDate ||
                    !values.entryTime ||
                    isSubmitting
                  }
                  onClick={() => {
                    Modal.confirm({
                      title: "Are you sure you want to mark attendance?",
                      okText: "Yes",
                      cancelText: "Cancel",
                      onOk: () => submitForm(),
                    });
                  }}
                >
                  Submit
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default MarkAttModal;
